import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 22
  });
  useEffect(() => {
    const KEY = 'acuiculturaProEndTime';
    const DURATION = 23 * 60 * 60 * 1000 + 47 * 60 * 1000 + 22 * 1000;
    const saved = localStorage.getItem(KEY);
    let endTime: number;
    if (saved) {
      endTime = parseInt(saved, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + DURATION;
        localStorage.setItem(KEY, endTime.toString());
      }
    } else {
      endTime = Date.now() + DURATION;
      localStorage.setItem(KEY, endTime.toString());
    }
    const interval = setInterval(() => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        const newEnd = Date.now() + DURATION;
        localStorage.setItem(KEY, newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(diff / (1000 * 60 * 60) % 24),
        minutes: Math.floor(diff / 1000 / 60 % 60),
        seconds: Math.floor(diff / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2 md:gap-3 ${className}`} data-id="element-55">
      <Box value={fmt(timeLeft.hours)} label="HORAS" data-id="element-56" />
      <span className="text-2xl md:text-4xl font-black text-brand-orange" data-id="element-57">
        :
      </span>
      <Box value={fmt(timeLeft.minutes)} label="MIN" data-id="element-58" />
      <span className="text-2xl md:text-4xl font-black text-brand-orange" data-id="element-59">
        :
      </span>
      <Box value={fmt(timeLeft.seconds)} label="SEG" data-id="element-60" />
    </div>;
}
function Box({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-61">
      <div className="bg-white text-brand-navy font-display font-bold text-2xl md:text-4xl lg:text-5xl px-3 py-1.5 md:px-4 md:py-2 rounded-md border-b-4 border-brand-orange min-w-[56px] md:min-w-[80px] text-center" data-id="element-62">
        {value}
      </div>
      <span className="text-[9px] md:text-xs font-bold text-white mt-1 tracking-widest" data-id="element-63">
        {label}
      </span>
    </div>;
}